<template lang="pug">
div 
    b-container
        b-card(v-if="updateRequired")
          b-row
            b-col.text-center
              h1.mt-5.mb-3 Update Required
              b-img#logo.mx-auto.d-block.mt-5(fluid src="/LCSS-wo-background.png" alt="LCSS")
              p.mt-5 A new version of the app ({{newVersion}}) is available. Please reload to continue.
              b-button.mt-3(variant="secondary" size="lg" @click="reloadApp")
                b-icon.mr-2(icon="arrow-clockwise")
                | Reload &amp; Update
        b-card(v-else-if="maintenance.crf69_configstatus")
          b-row
            b-col.text-center
              h1.mt-5.mb-3 Maintenance Mode
              b-img#logo.mx-auto.d-block.mt-5(fluid src="/maintenance.jpg" alt="LCSS")
              p.mt-5 Heya, Volunteers! The app is currently undergoing maintenance, please try again later.
              p.mt-4 Estimated to finish at: 
                span.text-danger {{ formatTime(maintenance.crf69_endtime) }}
              p.mt-4 (The maintenance is extended for further testing and improvements. We appreciate your patience)
        b-card#signinapp(no-body v-else)
          b-card-body(style="width:100%")
            
            b-img#logo.mx-auto.d-block(fluid src="/LCSS-wo-background.png" alt="LCSS")
            h4#landingtitle.mb-2 LCSS VOLUNTEER APP
            hr
            h4#landingtitle Login
            p.my-3(v-if="currentVersion").text-muted.text-center Version: {{currentVersion}}
            //-b-card-body#btncon
              b-button-group(vertical)
                //b-button.ld-group(id="ms-signin" @click="" ) Sign in with Microsoft
                //b-button.ld-group(id="gg-signin") Sign in with Google
                //b-button#sms-signin(variant="link") Sign in via SMS
            br
            //- label.ml-2.h6 
            //-   strong Sign In Code
            b-input.signInInput.mb-3(v-model="c" size="lg"  placeholder="Sign in Code")
            //- label.ml-2.h6
            //-   strong Mobile Number
            .text-center.mb-3.d-flex.justify-content-center.align-items-center(v-if="!ready") 
              b-spinner(label="Spinning")
              h5.mx-2.my-auto Fetching Phone Number
            b-input.signInInput.mb-3(v-if="ready" v-model="n" size="lg" type="tel" autocomplete="tel" placeholder="Mobile Number")
            p.text-center.mb-2(v-if="feedback.message" :class="feedbackClass") {{ feedback.message }}
            b-button.signInButton.mb-2(v-if="c && n" variant="secondary" size="lg" block @click="signinotp" :disabled="otpCooldown > 0 || smsDisabledByEmail || isSendingSms")
              b-icon.mr-3(icon="chat-right-text-fill")
              span(v-if="otpCooldown > 0") Resend in {{ otpCooldown }}s
              span(v-else-if="smsDisabledByEmail") SMS OTP disabled after Email OTP request
              span(v-else) Get OTP
            b-collapse.my-2(v-model="otpRequested")
              hr
              b-input.signInInput.mb-3(v-model="o" size="lg" placeholder="Enter OTP" auto-complete="one-time-code")
              b-button.signInButton.mb-3(
                v-if="otpRequested && otpCooldown === 0 && smsTimeoutCompleted && hasEmail"
                variant="outline-secondary"
                size="lg"
                block
                @click="requestEmailOtp"
                :disabled="emailCooldown > 0 || isSendingEmail"
              )
                b-icon.mr-3(icon="envelope-fill")
                span(v-if="emailCooldown > 0") Resend Email OTP in {{ emailCooldown }}s
                span(v-else) Request OTP via Email
              p.text-danger.mb-3.text-center(v-if="otpRequested && otpCooldown === 0 && smsTimeoutCompleted && !hasEmail")
                | Email OTP unavailable: no email found for this volunteer.
              b-button.signInButton.mb-3(variant="secondary" size="lg" block @click="signin" :disabled="isSendingSms || isSendingEmail")
                b-icon.mr-3(icon="box-arrow-in-right")
                | Verify & Sign In
    //- div(v-show="!isShow") Profile page
    //-   b-container.container-lg
</template>

<script>
import dayjs from 'dayjs';
import axios from "axios";
export default {
  name: "landingMb",
  data() {

    let c = this.$route.query.c ||localStorage.getItem("lastuser") ||"";
    let n = localStorage.getItem("lastmobile")||"";

    return {
      c,
      n,
      ready:false,
      access: null,
      o:"",
      otpRequested:false,
      maintenance: {},
      updateRequired: false,
      newVersion: null,
      currentVersion: localStorage.getItem('app_version') || 'N/A',
      otpCooldown: 0,
      cooldownInterval: null,
      emailCooldown: 0,
      emailCooldownInterval: null,
      hasEmail: false,
      smsTimeoutCompleted: false,
      otpChannel: 'sms',
      smsDisabledByEmail: false,
      isSendingSms: false,
      isSendingEmail: false,
      feedback: {
        type: '',
        message: ''
      }
    };
  },

  computed: {
    feedbackClass(){
      if(this.feedback.type === 'error') return 'text-danger';
      if(this.feedback.type === 'success') return 'text-success';
      return 'text-muted';
    }
  },

  async mounted(){

    let  { data } = await axios.get("/api/maintenance_mode");
    this.maintenance = data.maintenance || {};

    const remoteVersion = data.app_version?.crf69_value;
    if (remoteVersion) {
      const localVersion = localStorage.getItem('app_version');
      if (!localVersion) {
        localStorage.setItem('app_version', remoteVersion);
        this.currentVersion = remoteVersion;
      } else if (localVersion !== remoteVersion) {
        this.updateRequired = true;
        this.newVersion = remoteVersion;
        return;
      }
    }

    if(!this.c){
      this.ready=true;
    }
    if(this.c){
      let arr =  [axios.get("/api/phonenumber").then(({data})=>{//bad naming convention probably.
        console.log(data[0])
        this.n=(data[0].crf69_Contact.crf69_number).replace(/\s/g, '')
        this.hasEmail = Boolean(data?.[0]?.crf69_Contact?.crf69_email)
        // this.access = data[0].crf69_mobileappaccess;
        return data;
      })];
      Promise.all(arr).then(()=>{
        this.ready = true;
      }).catch((error)=>{
          alert(error.response?.data || error.message || "Sign-in again");
          this.ready=true;
      })

    }
  },

  methods:{
    setFeedback(type, message){
      this.feedback = {type, message};
    },
    startSmsCooldown(){
      this.otpCooldown = 60;
      if(this.cooldownInterval){
        clearInterval(this.cooldownInterval);
      }
      this.cooldownInterval = setInterval(() => {
        this.otpCooldown--;
        if (this.otpCooldown <= 0) {
          clearInterval(this.cooldownInterval);
          this.smsTimeoutCompleted = true;
          if(this.hasEmail){
            this.setFeedback('info', "Didn't receive SMS? You can request OTP via Email now.");
          }
        }
      }, 1000);
    },
    startEmailCooldown(){
      this.emailCooldown = 60;
      if(this.emailCooldownInterval){
        clearInterval(this.emailCooldownInterval);
      }
      this.emailCooldownInterval = setInterval(() => {
        this.emailCooldown--;
        if(this.emailCooldown <= 0){
          clearInterval(this.emailCooldownInterval);
        }
      }, 1000);
    },
    async checkEmailEligibility(){
      let {c,n} = this;
      if(!c || !n){
        this.hasEmail = false;
        return;
      }
      c = c.replace(/[^a-fa-f0-9-]/g, "");
      let params= new URLSearchParams({c,n,check:'eligibility'});
      try {
        let {data} = await axios.get("/api/login_email?"+params.toString());
        this.hasEmail = Boolean(data?.hasEmail);
      } catch {
        this.hasEmail = false;
      }
    },
    reloadApp(){
      localStorage.removeItem('app_version');
      window.location.reload();
    },
    formatTime(val){
      return dayjs(val).format("DD/MM/YYYY (hh:mm: A)");
    },
    async signinotp(){
      if (this.otpCooldown > 0 || this.smsDisabledByEmail) return;
      this.isSendingSms = true;

      let {c,n} = this;
      c = c.replace(/[^a-fa-f0-9-]/g, "");
      let params= new URLSearchParams({c,n});
      try {
        await axios.get("/api/login?"+params.toString());
        this.otpRequested = true;
        this.otpChannel = 'sms';
        this.smsDisabledByEmail = false;
        this.setFeedback('success', 'SMS OTP sent.');
        await this.checkEmailEligibility();
        this.startSmsCooldown();
      } catch (error) {
        const msg = error.response?.data;
        this.setFeedback(
          'error',
          (typeof msg === 'string' ? msg : msg?.message ? msg.message : null)
          || error.message
          || 'Unable to send SMS OTP'
        );
      } finally {
        this.isSendingSms = false;
      }
    },
    async requestEmailOtp(){
      if(this.emailCooldown > 0) return;
      this.isSendingEmail = true;
      let {c,n} = this;
      c = c.replace(/[^a-fa-f0-9-]/g, "");
      let params= new URLSearchParams({c,n});
      try {
        await axios.get("/api/login_email?"+params.toString());
        this.otpRequested = true;
        this.otpChannel = 'email';
        this.smsDisabledByEmail = true;
        this.startEmailCooldown();
        this.setFeedback('success', 'Email OTP sent. Please check your inbox.');
      } catch (error) {
        const msg = error.response?.data;
        this.setFeedback(
          'error',
          (typeof msg === 'string' ? msg : msg?.message ? msg.message : null)
          || error.message
          || 'Unable to send email OTP'
        );
      } finally {
        this.isSendingEmail = false;
      }
    },
    signin(){
      console.log("logging in");
      localStorage.removeItem('loggedOut');
      let {c,n,o} = this;
      c = c.replace(/[^a-fa-f0-9-]/g, "");
      let params= new URLSearchParams({c,n,o});
      if(this.otpChannel === 'email'){
        params.set('ch','email');
      }
      window.location.href= "/profile?"+params.toString();
    },
  },
  watch:{
    c(){
      this.otpRequested = false;
      this.smsTimeoutCompleted = false;
      this.otpChannel = 'sms';
      this.hasEmail = false;
      this.smsDisabledByEmail = false;
      this.emailCooldown = 0;
      this.otpCooldown = 0;
      this.setFeedback('', '');
    },
    n(){
      this.otpRequested = false;
      this.smsTimeoutCompleted = false;
      this.otpChannel = 'sms';
      this.hasEmail = false;
      this.smsDisabledByEmail = false;
      this.emailCooldown = 0;
      this.otpCooldown = 0;
      this.setFeedback('', '');
    }
  },
  beforeDestroy() {
    if (this.cooldownInterval) {
      clearInterval(this.cooldownInterval);
    }
    if(this.emailCooldownInterval){
      clearInterval(this.emailCooldownInterval);
    }
  }
}
</script>

<style lang="scss" scoped>
#logo{
  width:18rem;
  height:18rem;
  object-fit: contain;
}

.signInInput{
  border-radius: 20px;
}

.signInButton{
  border-radius:20px;
}

label{
  color:#26263e;
}
</style>